<!--
 * @Author: Merlin
 * @Date: 2023-12-14 13:34:24
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-01 16:44:07
 * @Description: 
-->

<template>
    <div class="w-full">
        <h5 class="section-title">
            {{ $t('redPacketMines.PacketSenderInfo') }}:
        </h5>
        <div class="bg-background-80 rounded-xl text-sm p-4 gap-3 flex flex-col font-bold">
            <div class="text-grey-40 inline-flex justify-between items-center w-full">
                <span>
                    {{ $t('redPacketMines.packetSender') }}:
                </span>
                <span class="inline-flex gap-2 items-center">
                    <UserAvatar
                        class="shrink-0 "  
                        size="20px"
                        :src="history.senderInfo.send_user_avatar" 
                    />
                    {{ history.senderInfo.send_name }}
                </span>
            </div>
            <div class="text-grey-40 inline-flex justify-between items-center w-full">
                <span>
                    {{ $t('redPacketMines.SentAt') }}:
                </span>
                <span>
                    {{ fnGetTime(history.senderInfo.timestamp).join(' ') }}
                </span>
            </div>
        </div>

        <div class="analysis gap-2">
            <div class="gray-box">
                <h6 class="title">
                    {{ $t('redPacketMines.PacketAmount') }}
                </h6>
                <em class="quantity">
                    <CurrentCoin :name="history.senderInfo.currency" />
                    {{ getFixed(history.senderInfo.amount) }}
                </em>
            </div>
            <div class="gray-box">
                <h6 class="title">
                    {{ $t('Multiplier') }} 
                </h6>
                <em class="quantity">
                    x{{ getFixed(Number(history.senderInfo?.multi)) }}
                </em>
            </div>
            <div class="gray-box min-w-full">
                <h6 class="title">
                    {{ $t('redPacketMines.Profit1') }}
                </h6>
                <em class="quantity"
                    :class="{won: history.senderInfo.winAmountAfterTax > 0}"
                >
                    <CurrentCoin :name="history.senderInfo.currency" />
                    <Popper
                        :style="oPopperStyle"
                        :hover="true"
                        :arrow="true"
                        placement="top"
                    >   
                        <CasinoWidgetColoredAmount
                            class="font-semibold"
                            :amount="Number(getFixed(history.senderInfo.winAmountAfterTax))" 
                            :colors="['', 'rgb(85,101,126)' ]"
                        ></CasinoWidgetColoredAmount>
                        <template #content>
                            <div class="popper-content"> 
                                <CurrentCoin
                                    class="inline-flex"
                                    :name="history.senderInfo.currency"
                                />
                                {{ getFixed(history.senderInfo.winAmountAfterTax, 4) }} 
                            </div>
                        </template>
                    </Popper>
                </em>
            </div>
            <div class="gray-box">
                <h6 class="title">
                    {{ $t('redPacketMines.packetLeft') }}
                </h6>
                <em class="quantity">
                    <img src="@/pages/casino/redpacketGame/img/small_pack.png" />
                    {{
                        history.senderInfo.num - tableArr.length 
                    }}/{{
                        history.senderInfo.num
                    }}
                </em>
            </div>
            <div class="gray-box">
                <h6 class="title">
                    {{ $t('redPacketMines.BombNumber') }}
                </h6>
                <em class="quantity">
                    <img src="@/pages/casino/redpacketGame/img/small_bomb.png" />
                    {{ history.senderInfo.mine }}
                </em>
            </div>
        </div>
        <!-- 
            ↑ 发包人
            | ================================================== 
            ↓ 抢包人 
        -->
        <h5 class="section-title">
            {{ $t('redPacketMines.PacketGraberInfo') }}:
        </h5>
        <div class="big-list gray-box">
            <!-- 设定 rowsPerPage >= 10 即可，因为最多10行数据（10人抢包） -->
            <q-table
                :pagination="{rowsPerPage: 100}"
                hide-pagination
                row-key="name"
                :no-data-label="$t('Noinformation')"
                :rows="tableArr"
                :columns="oActiveTable.aColumns" 
                table-class="big-table"
            >
                <template v-slot:body="props">
                    <q-tr :props="props">
                        <q-td class="td-user" key="date">
                            <div class="td-inner"
                                :data-t01="JSON.stringify(props)" 
                            >
                                <UserAvatar
                                    class="shrink-0"  
                                    size="20px"
                                    :src="props.row.user_avatar"
                                />
                                <span class="text">
                                    <span class="truncate">
                                        {{ props.row.user_name }}
                                    </span>
                                    <time class="truncate">
                                        {{ fnGetTime(props.row.timestamp)[1] }} 
                                    </time>
                                </span>
                            </div>
                        </q-td>
                        <q-td class="" key="name">
                            <div class="td-inner w-[18px]">
                                <img v-if="props.row.is_mine"
                                    class="w-[18px]"
                                    src="@/pages/casino/redpacketGame/img/small_bomb.png" 
                                />
                                <img v-else-if="props.row.isChampion" 
                                    class="w-[18px]"
                                    src="@/assets/imgs/trophy.png"
                                />
                            </div>
                        </q-td>
                        <q-td class="td-amount" key="name">
                            <div class="td-inner ">
                                <CurrentCoin
                                    size="18px"
                                    class=""
                                    :name="history.senderInfo.currency"
                                />
                                <span class="flex flex-col">  
                                    <span class="text">
                                        {{ getFixed(props.row.sharedAmount) }}
                                    </span>
                                    <span class="text loose mt-[2px] ml-[-2px]"
                                        v-if="props.row.mineAmount || props.row.is_mine" 
                                    >
                                        -{{ getFixed(props.row.mineAmount) }}
                                    </span>
                                </span>
                            </div>
                        </q-td>
                        <q-td class="td-profit" key="amountInUsd">
                            <div class="td-inner ">
                                <CurrentCoin
                                    size="18px"
                                    class=""
                                    :name="history.senderInfo.currency"
                                />
                                <span class="text"
                                    :class="{
                                        won: props.row.winAmountFinal > 0,
                                        loose: props.row.winAmountFinal < 0,
                                    }"
                                >
                                    <Popper
                                        :style="oPopperStyle"
                                        :hover="true"
                                        :arrow="true"
                                        placement="top"
                                    >   
                                        <CasinoWidgetColoredAmount
                                            class="font-semibold"
                                            :colors="['', 'rgb(85,101,126)']"
                                            :amount="Number(getFixed(props.row.winAmountFinal))" 
                                        ></CasinoWidgetColoredAmount>
                                        <template #content>
                                            <div class="popper-content"> 
                                                <CurrentCoin
                                                    size="18px"
                                                    class="inline-flex"
                                                    :name="history.senderInfo.currency"
                                                />
                                                {{ getFixed(props.row.winAmountFinal, 4) }} 
                                            </div>
                                        </template>
                                    </Popper>
                                </span>
                            </div>
                        </q-td>
                    </q-tr>
                </template>
                <template v-slot:no-data="{ message }">
                    <p class="no-data-message">
                        {{ message }}
                    </p>
                </template>
            </q-table>
        </div>
    </div>
</template>

<script lang="ts" setup>
import Popper from "vue3-popper";
import useGlobalStore from '@/stores/global';
import moment from 'moment';

const props = defineProps({
    modelValue: Boolean, // 
    backdrop: {
        type: Boolean,
        default: true,
    },
    history: {
        type: Object,
        default: () => ({}),
    },
});

const oGlobalStore = useGlobalStore();
const emit = defineEmits(['update:modelValue']);
const {t: $tFn, locale} = useNuxtApp().$i18n;


// 主表数据 
const tableArr = computed(()=>{
    const arr = props.history['history_detail_list'] || [];
    return arr; 
});


const obj01 = {field: '', name: ''}; 
const oActiveTable = reactive({
    aColumns: [{
        ...obj01,
        label: $tFn('USER'), 
    },{
        ...obj01,
        label: '', 
    },{
        ...obj01,
        label: $tFn('redPacketMines.AmountReceived'),
    },{
        ...obj01,
        label: $tFn('redPacketMines.Profit'),
    }],
}); 

const fnGetTime = (
    ts:number, 
)=>{
    // const ts = Date.now(); 
    const sFormst = (
        locale.value === 'cn'
        ? 'YYYY/MM/DD HH:mm:ss'
        : 'MM/DD/YYYY hh:mm:ss A'
    );
    const sTime = moment(ts).format(sFormst);
    const aTime = sTime.split(' ');
    return [
        aTime[0],
        aTime.slice(1).join(' '),
    ];
}

onMounted(()=>{
    // console.log('历史数据：', deepCopy(props.history)); 
});

</script>


<style lang="scss" scoped>
.back-btn{
    width: 33px;
    height: 33px;
    border-radius: 8px;
    background: #263F5C;
    color: white; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    font-size: 26px;
    margin: 0 5px 0 0;
}

.section-title{
    color: rgb(85 101 126); 
    font-weight: 600; 
}

.won{
    color: rgba(27, 184, 61, 1) !important; 
}

.gray-box{
    // background: rgba(32, 42, 57, 1);
    background-color: #161F2C; // 与窗口其它元素颜色一致 
    padding: 12px;
    border-radius: 8px; 
}

.analysis{
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    // align-items: center; 
    flex-wrap: wrap;
    flex-direction: row; 
    
    & > * {
        min-height: 55px; // 与临近元素等高 
        padding-top: 10px;
        padding-bottom: 10px;
        flex: 1 1 40%; 
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }
    .title{
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: rgba(147, 172, 211, 1);
        margin: 0 0 5px; 
    }
    .quantity{
        color: white; 
        font-weight: 500; 
        font-size: 16px;
        display: flex;
        align-items: center; 
        img{
            width: 20px; 
            margin: 0 6px 0 -3px; 
        }
    }
}

.big-list{
    & > .q-table__card{
        background-color: transparent; 
        box-shadow: none; 
    }
    & :deep(table.q-table){
        width: 100%;
        overflow: hidden;
        background-color: transparent; 
        tr{
            // border-bottom: 0.5px solid var(--bet-corgi-color-white-12, rgba(255, 255, 255, 0.12))
            border-bottom: solid 1px rgba(255, 255, 255, 0.15);
        }
        body tr:hover{
            background-color: rgba(0, 0, 0, 0.1); 
        }
        th{
            color: rgba(85, 101, 126, 1);
            font-size: 12px; 
            text-align: left;
        }
        td{
            opacity: 1; 
        }
        th, td{
            padding-left: 4px;
            padding-right: 4px;
        }
    }
    td{
        .td-inner{
            font-size: 14px;
            line-height: 14px;
            vertical-align: middle;
            display: flex;
            align-items: center; 
            overflow: hidden; 
            max-width: 99%;
            min-height: 45px;
            padding: 5px 0; 
            .user-avatar,
            img{
                margin: 0 5px 0 0;
            }
            .text{
                min-width: 10px; 
            }
        }
        // ↓ 触雷后支付的金额 
        .loose{
            color: rgba(237, 29, 73, 1); 
        } 
    }
    .td-user{
        color: white;
        font-weight: 600;
        .text{
            font-size: 12px;
            & > *{
                display: block; 
            }
            time{
                font-size: 11px;
                color: rgba(167, 181, 202, 1); 
            }
        }
    }

    .td-amount{
        color: rgba(147, 172, 211, 1); 
        font-weight: 600; 
        img{
            display: inline-block;  
        }
    }
    .td-profit{
        font-weight: 600; 
        color: rgba(147, 172, 211, 1); 
    }
}


</style>


